
import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as audioActions from '../../../../Core/Game/AudioContainer/audio.actions'

import UserShield from '../../../Components/UserShield'

const COLORS = [
  'black',
  'white',
  'green',
  'orange',
  'lightgreen',
  'yellow',
  'lightgrey',
  'grey',
  'lightblue',
  'red',
  'blue',
]

class ColonyShield extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      bannerGeometry: '',
      bannerColor: '',
      emblemColor: '',
      emblemGeometry: '',
    }
  }

  componentDidMount() {
    const { shield } = this.props
    const { randomBannerGeometry, randomBannerColor, randomEmblemColor, randomEmblemGeometry } =
      this.generateRandomShield()

    this.setState({
      bannerGeometry: shield.bannerGeometry ? shield.bannerGeometry : randomBannerGeometry,
      bannerColor: shield.bannerColor ? shield.bannerColor : randomBannerColor,
      emblemColor: shield.emblemColor ? shield.emblemColor : randomEmblemColor,
      emblemGeometry: shield.emblemGeometry ? shield.emblemGeometry : randomEmblemGeometry,
      activeBlock: 1,
    })
  }

  selectBannerGeometry(code) {
    const { addHowlSound } = this.props
    this.setState({
      bannerGeometry: code,
      activeBlock: 1,
    })
    addHowlSound('button_click')
  }

  selectBannerColor(color) {
    const { addHowlSound } = this.props
    this.setState({
      bannerColor: color,
    })
    addHowlSound('button_click')
  }
  selectEmblemColor(color) {
    const { addHowlSound } = this.props
    this.setState({
      emblemColor: color,
    })
    addHowlSound('button_click')
  }

  selectEmblemGeometry(code) {
    const { addHowlSound } = this.props
    this.setState({
      emblemGeometry: code,
      activeBlock: 2,
    })
    addHowlSound('button_click')
  }

  generateRandomShield() {
    const randomBannerGeometry = Math.floor(Math.random() * 12)
    const randomBannerColor = COLORS[Math.floor(Math.random() * COLORS.length)]
    const randomEmblemColor = COLORS[Math.floor(Math.random() * COLORS.length)]
    const randomEmblemGeometry = Math.floor(Math.random() * 12)

    return {
      randomBannerGeometry: randomBannerGeometry,
      randomBannerColor: randomBannerColor,
      randomEmblemColor: randomEmblemColor,
      randomEmblemGeometry: randomEmblemGeometry,
    }
  }

  setRandomShield() {
    const { randomBannerGeometry, randomBannerColor, randomEmblemColor, randomEmblemGeometry } =
      this.generateRandomShield()
    const { addHowlSound } = this.props
    addHowlSound('button_click')
    this.setState({
      bannerGeometry: randomBannerGeometry,
      bannerColor: randomBannerColor,
      emblemColor: randomEmblemColor,
      emblemGeometry: randomEmblemGeometry,
    })
  }

  next() {
    const { next, addHowlSound } = this.props
    const { bannerGeometry, bannerColor, emblemColor, emblemGeometry } = this.state
    next({ bannerGeometry, bannerColor, emblemColor, emblemGeometry })
    addHowlSound('button_click_icon')
  }

  renderSelectBannerGeometry() {
    return (
      <div
        className={
          this.state.activeBlock === 1 ? 'settings--selector active' : 'settings--selector'
        }
      >
        <div className="settings--name">
          <FormattedMessage id={'colony.selectBannerGeometry'} />
        </div>
        <div className="settings--items">
          {[...Array(12)].map((e, i) => (
            <span
              className={'icon-shield-' + (i + 1)}
              key={i + 1}
              onClick={() => {
                this.selectBannerGeometry(i + 1)
              }}
            ></span>
          ))}
        </div>
      </div>
    )
  }

  renderSelectEmblem() {
    return (
      <div
        className={
          this.state.activeBlock === 2 ? 'settings--selector active' : 'settings--selector'
        }
      >
        <div className="settings--name">
          <FormattedMessage id={'colony.selectEmblem'} />
        </div>
        <div className="settings--items">
          {[...Array(12)].map((e, i) => (
            <span
              className={'icon-emblem-' + (i + 1)}
              key={i + 1}
              onClick={() => {
                this.selectEmblemGeometry(i + 1)
              }}
            ></span>
          ))}
        </div>
      </div>
    )
  }

  renderSelectColor() {
    return (
      <div className="settings--selector picker">
        <div className="settings--name">
          <FormattedMessage id={'colony.selectColorEmblem'} />
        </div>
        <div className="settings--items">
          {COLORS.map((color) => (
            <span
              className={'icon-circle shield--' + color}
              key={color}
              onClick={() => {
                this.selectEmblemColor(color)
              }}
            ></span>
          ))}
        </div>
      </div>
    )
  }
  renderSelectColorBanner() {
    return (
      <div className="settings--selector picker">
        <div className="settings--name">
          <FormattedMessage id={'colony.selectColor'} />
        </div>
        <div className="settings--items">
          {COLORS.map((color) => (
            <span
              className={'icon-circle shield--' + color}
              key={color}
              onClick={() => {
                this.selectBannerColor(color)
              }}
            ></span>
          ))}
        </div>
      </div>
    )
  }
  renderShield() {
    const { name } = this.props
    return (
      <div className="settings--customization__shield">
        <span className="settings--title__name">{name}</span>
        <UserShield shield={this.state} />
        <div className="btn--random">
          <span
            className="icon-random"
            onClick={() => {
              this.setRandomShield()
            }}
          >
            {' '}
          </span>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div>
        <div className="container background background--challenge">
          <div className="content">
            <div className="settings">
              <div className="settings--content ">
                <div className="settings--title">
                  <FormattedMessage id={'colony.configure'} />
                </div>
                <div className="settings--customization">
                  {this.renderShield()}
                  <div className="settings--customization__options">
                    <div className="settings--block">
                      {this.renderSelectBannerGeometry()}
                      {this.renderSelectEmblem()}
                    </div>
                    <div className="settings--block">
                      {this.state.activeBlock === 1
                        ? this.renderSelectColorBanner()
                        : this.renderSelectColor()}
                    </div>
                  </div>
                </div>
                <div className="settings--buttons">
                  <div onClick={() => this.next()} className="btn--orange">
                    <span className="icon-planet"></span>
                    <span>
                      <FormattedMessage id={'colony.nextStep'} />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),
  }
}
ColonyShield.propTypes = {
  shield: PropTypes.object,
  name: PropTypes.string,
  next: PropTypes.func,
  addHowlSound: PropTypes.func,
}

export default connect(null, mapDispatchToProps)(injectIntl(ColonyShield))
